<div class="loading-error-container"> 
  <h1 class="title">
    Sorry, we’re having trouble loading your results. 
  </h1>
  <h2 class="details">
    Try adjusting your filters or refreshing the page. 
  </h2>
</div>